import React, {useState} from 'react';
import {problemListFields} from "../../network/mockData";
import Issues from "./Issues";
import {Calendar} from "primereact/calendar";
import {Checkbox} from 'primereact/checkbox';
import {dateToDMY, getDateOffsetByDays} from "../../utils/dateUtils";




function ClosedIssues(props) {
    const [ dateFrom, setDateFrom ] = useState(getDateOffsetByDays(-7));
    const [ dateTo, setDateTo ] = useState(getDateOffsetByDays(0));
    const [ includeOpenIssues, setIncludeOpenIssues ] = useState(false);
    const dateFromString = dateToDMY(dateFrom);
    const dateToString = dateToDMY(dateTo);
    const exportUrl = `problem/admin/problems/excel?creationfromdate=${dateFromString}&creationtodate=${dateToString}${includeOpenIssues ? "" : "&status=Resolved&status=Unresolved"}`;
    const exportFileName = `export_${includeOpenIssues ? "all" : "closed"}_issues_from_${dateFromString.replace(/\//g, "-")}_to_${dateToString.replace(/\//g, "-")}.xls`;

    return (
        <div className="mt-4">
            <Issues
                dataUrl={`problem/admin/problems?status=Resolved&status=Unresolved&creationfromdate=${dateFromString}&creationtodate=${dateToString}`}
                tableFields={problemListFields}
                exportUrl={exportUrl}
                exportFileName={exportFileName}>
                <>
                    <div className="w-full flex mb-4">
                        <div>
                            <label htmlFor="date-from-input"> Date from </label>
                            <div>
                                <Calendar inputId="date-from-input"
                                          dateFormat="dd/mm/yy"
                                          value={dateFrom}
                                          onChange={(e) => setDateFrom(e.value)}/>
                            </div>
                        </div>


                        <div className="ml-6">
                            <label htmlFor="date-to-input"> Date to </label>
                            <div>
                                <Calendar inputId="date-to-input"
                                          dateFormat="dd/mm/yy"
                                          value={dateTo}
                                          onChange={(e) => setDateTo(e.value)}/>
                            </div>
                        </div>
                    </div>

                    <div>
                        <Checkbox inputId="includeOpenIssuesCheckbox" onChange={e => setIncludeOpenIssues(e.checked)} checked={includeOpenIssues}></Checkbox>
                        <label className="ml-2" htmlFor="includeOpenIssuesCheckbox">Include open issues in export</label>
                    </div>
                </>
            </Issues>
        </div>
    );
}

export default ClosedIssues;
